import { InstantCompare } from '@airreading/common';
import { ReactNode } from 'react';
import { Temporal } from 'temporal-polyfill';

import { RequestSubstituteConfirmDialog } from '@/components/session/request-substitute-confirm-dialog.js';
import { SubstituteNotAvailableDialog } from '@/components/session/substitute-not-available-dialog.js';

interface RequestSessionSubstituteProps {
  sessionId: string;
  studentGroupId: string;
  startInstant: Temporal.Instant;
  endInstant: Temporal.Instant;
  trigger: ReactNode;
  disabled?: boolean;
}

function isSessionPastOrAtStart(startInstant: Temporal.Instant): boolean {
  return InstantCompare(Temporal.Now.instant()).isAfterOrEqual(startInstant);
}

export const RequestSessionSubstitute = (props: RequestSessionSubstituteProps) => {
  const sessionHasStarted = isSessionPastOrAtStart(props.startInstant);

  if (sessionHasStarted) {
    return <SubstituteNotAvailableDialog trigger={props.trigger} disabled={props.disabled} />;
  }

  return <RequestSubstituteConfirmDialog {...props} />;
};
